import React, { Component, createRef } from "react";
import { connect } from "react-redux";
import { View, Image, TouchableOpacity, ScrollView, SafeAreaView, StyleSheet } from 'react-native'
import { Header, TaskSuccess, Recorder, Label, Form } from "../../../components/SharedComponents";
import { secondsToTime } from "../../../shared/functions";
import actions from "../../../actions";
import styles from "../../../shared/styles";
import { colors, action } from "../../../utils";
import { FontAwesomeIcon as Icon } from "@fortawesome/react-fontawesome"
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { faStopCircle, faPlayCircle } from "@fortawesome/free-regular-svg-icons";
import { WaveIcon } from "../../../assets";
import localize from "../../../shared/localize";

const { currentStrangth, getUserFamilyGroup, getDailyRiddleQuestion, answerDailyRiddleQuestion } = actions;

class DailyRiddle extends Component {
    arcRefs = null;

    constructor(props) {
        super(props);
        this.recorder = createRef();
        this.state = {
            status: false,
            duration: undefined,
            recordingTimer: undefined,
            audioBase64: undefined,
            isRecording: false,
            isRecorded: false,
            isPlay: false,
            playTimer: undefined,
        }
    }

    componentDidMount = () => {
        this.props.getDailyRiddleQuestion();
    }

    onRiddleComplete = async () => {
        try {
            const { audioBase64, duration, isRecorded } = this.state;
            if (!isRecorded) return;
            let daily_riddle = this.props.daily_riddle
            if (daily_riddle.status === 201) return this.setState({ status: true })
            const response = await this.props.answerDailyRiddleQuestion({ question_id: daily_riddle.id, data: audioBase64, duration });
            if (response)
                return this.setState({ status: true })
        } catch (error) {
            console.log(error)
        }
    }

    _navigateChat = async () => {
        const group = await this.props.getUserFamilyGroup();
        if (group.group_chat_id && group.group_chat_name && group.group_chat_id !== '') {
            return this.props.history.push({
                pathname: "/chat/conversation",
                state: { groupId: group.group_chat_id, name: group.group_chat_name },
                search: `?groupId=${group.group_chat_id}&name=${group.group_chat_name}`
            });
        }
        return this.props.history.push("dashboard");
    }

    _recordingProgress = (recordingTimer) => {
        this.setState({ recordingTimer, isRecording: true, isPlay: false })
    }

    _receiveVoice = (audioPath, audioBase64, duration) => {
        this.setState({ recordingTimer: undefined, isRecording: false, audioBase64, duration, isRecorded: true })
    }

    _removeVoice = () => {
        if (!this.state.isRecorded) return;
        this.recorder.current.clearAudio();
    }

    _togglePlay = () => {
        if (!this.state.isRecorded) return;
        this.recorder.current.onPlay();
    }

    _playProgress = (playTimer) => {
        this.setState({ isPlay: true, playTimer });
    }

    _stopPlay = () => {
        this.setState({ isPlay: false, playTimer: undefined });
    }

    _clearVoice = () => {
        this.setState({ recordingTimer: undefined, isRecording: false, audioBase64: undefined, duration: undefined, isRecorded: false, isPlay: false })
    }

    render() {
        let { status, audioBase64, isRecording, playTimer, isPlay, isRecorded, recordingTimer, duration } = this.state;
        let { daily_riddle } = this.props;

        let timer = 0;
        if (isRecording) timer = recordingTimer
        else if (isPlay) timer = playTimer
        else if (isRecorded) timer = duration
        timer = secondsToTime(timer)
        return (
            <SafeAreaView style={styles.container}>
                {
                    status ? <Header title={localize.daily_riddle} /> : <Header title={localize.daily_riddle} goBack={() => this.props.history.goBack()} />
                }
                <ScrollView
                    keyboardShouldPersistTaps="handled"
                    style={{ padding: 15 }}
                >
                    {
                        status ?
                            <TaskSuccess
                                title={localize.thank_you_for_completing_riddle}
                                point={localize.points_14}
                                buttonPress={this._navigateChat}
                            /> :
                            <View style={{}}>
                                <Label.PrimaryTitle>
                                    {daily_riddle && daily_riddle.question}
                                </Label.PrimaryTitle>

                                <View style={{ alignSelf: "center", marginVertical: 20 }}>
                                    <Label.PrimaryCaption>
                                        {audioBase64 === null ? localize.record_your_answer : localize.re_record_your_answer}
                                    </Label.PrimaryCaption>
                                </View>

                                <View style={{ paddingVertical: 15, marginTop: 10 }}>
                                    <Recorder
                                        ref={this.recorder}
                                        onReceiveVoice={this._receiveVoice}
                                        onRecordingProgress={this._recordingProgress}
                                        onPlayProgress={this._playProgress}
                                        onPlayStop={this._stopPlay}
                                        onClearvoice={this._clearVoice}
                                        showExceptionDialog={() => this.props.showExceptionDialog()}
                                    />
                                </View>

                                <View
                                    style={[styles.inputField, { marginVertical: 20, justifyContent: "space-between", paddingHorizontal: 5 }, isRecorded ? styles.borderBlue : styles.borderGrey]}
                                >

                                    <View style={[pageStyles.progressArea, isRecorded ? styles.bgBlue : styles.bgDisabled]}>
                                        <TouchableOpacity
                                            onPress={this._togglePlay}
                                            activeOpacity={isRecorded ? 0.8 : 1}
                                        >
                                            <Icon
                                                icon={isPlay ? faStopCircle : faPlayCircle}
                                                color={colors.white}
                                                style={{ position: "static", fontSize: 30 }}
                                            />
                                        </TouchableOpacity>
                                        <View style={pageStyles.waveRow}>
                                            <Image source={WaveIcon} style={pageStyles.waveIc} />
                                            <Image source={WaveIcon} style={pageStyles.waveIc} />
                                            <Image source={WaveIcon} style={pageStyles.waveIc} />
                                        </View>
                                        <Label.CaptionLight>
                                            {timer}
                                        </Label.CaptionLight>
                                    </View>
                                    <TouchableOpacity
                                        onPress={this._removeVoice}
                                        activeOpacity={isRecorded ? 0.8 : 1}
                                    >
                                        <Icon
                                            icon={faTimesCircle}
                                            color={isRecorded ? colors.indigo : colors.disable}
                                            size="2x"
                                            style={{ position: "static" }}
                                        />
                                    </TouchableOpacity>
                                </View>

                                <View style={{ marginBottom: 60, marginHorizontal: 50 }}>
                                    <Form.Button
                                        title={localize.send_answer}
                                        size="small"
                                        disabled={!isRecorded}
                                        onPress={this.onRiddleComplete}
                                    />
                                </View>
                                <Label.SubtitleItalic>
                                    {localize.your_answer_will_be_shared}
                                </Label.SubtitleItalic>
                            </View>
                    }
                </ScrollView>
            </SafeAreaView>
        );
    }
}

const mapToProps = ({ main, auth }) => {
    return {
        daily_riddle: main.daily_riddle,
        userInfo: auth.userInfo,
    }
}
const mapDispatch = (dispatch) => {
    return {
        currentStrangth: () => dispatch(currentStrangth()),
        getDailyRiddleQuestion: () => dispatch(getDailyRiddleQuestion()),
        answerDailyRiddleQuestion: request => dispatch(answerDailyRiddleQuestion(request)),
        getUserFamilyGroup: () => dispatch(getUserFamilyGroup()),
        showExceptionDialog: () => dispatch({ type: action.RECORD_EXCEPTION_TRUE }),
    }
}
export default connect(mapToProps, mapDispatch)(DailyRiddle);

const pageStyles = StyleSheet.create({
    waveIc: {
        width: 28,
        height: 28,
        resizeMode: "contain"
    },
    waveRow: {
        flexDirection: "row",
        paddingHorizontal: 8
    },
    progressArea: {
        height: "75%",
        borderRadius: 20,
        flexDirection: "row",
        alignItems: "center",
        paddingLeft: 3,
        paddingRight: 5
    },
})